export const getSpreaderVideos = (state) =>
  state.spreaderVideos;



// WEBPACK FOOTER //
// ./src/store/selectors/speadervideos.js